import {
	provinceAndCityData,
	regionData,
	pcTextArr,
	pcaTextArr,
	codeToText
} from 'element-china-area-data'
import {
	ElPhoneNumberInput
} from 'el-phone-number-input'
import {
	postAction, getAction
} from '@/api/index';
import { Loading } from 'element-ui';
export default {
	components: {
		ElPhoneNumberInput
	},
	data() {
		/* 邮箱 */
		var isEmail = (rule, value, callback) => {
			if (!value) {
				callback()
			} else {
				const reg =
					/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/
				const email = reg.test(value)
				if (!email) {
					callback(new Error('邮箱格式如:admin@163.com'))
				} else {
					callback()
				}
			}
		}
		return {
			dialogVisible: false,
			url: {
				add: '/officialWebsite/c-api/sampleExperience/add',
				Info: '/officialWebsite/c-api/sampleExperience/get',
				sms: '/officialWebsite/c-api/sms',
				useGuideSetting: '/officialWebsite/c-api/setting/useGuide',
			},
			//手机号登录用
			stateSms: {
			  time: 60,
			  sendBtn: false,
			},
			loading: true,
			pcaTextArr: pcaTextArr,
			model: {
				id: '',
				fullName: '',
				email: '',
				companyName: '',
				address: [],
				phoneNumber: '',
				verCode: '',
				reqDes: ''
			},
			rules: {
				fullName: [{
						required: true,
						message: '请输入姓名',
						trigger: 'blur'
					},
					{
						min: 2,
						max: 20,
						message: '长度在 2 到 20 个字符',
						trigger: 'blur'
					}
				],
				email: [{
					required: true,
					message: '请输入邮箱',
					trigger: 'blur'
				}, {
					validator: isEmail,
					trigger: 'blur'
				}],
				companyName: [{
					required: true,
					message: '请输入单位名称',
					trigger: 'blur'
				}],
				address: [{
					required: true,
					message: '请选择省/自治区/直辖市',
					trigger: 'blur'
				}],
				phoneNumber: [{
					required: true,
					message: '请输入手机号码',
					trigger: 'blur'
				}, {
					pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
					message: "请输入正确的手机号码",
					trigger: "blur"
				}],
				verCode: [{
					required: true,
					message: '请输入验证码',
					trigger: 'blur'
				}],
				reqDes: [{
					required: true,
					message: '请填写您的重点需求描述',
					trigger: 'blur'
				}],
			},
			useGuide: ''
		}
	},
	mounted() {
		this.loadData();
	},
	methods: {
		async loadData() {
			const res = await getAction(this.url.Info, {isCache: false});
			if(res.success) {
				this.loading = false;
				if(res.result) this.model = res.result;
			}
			const res2 = await getAction(this.url.useGuideSetting);
			if(res2.success) {
				this.useGuide = res2.result;
			}
		},
		sendSms(e) {
			e.preventDefault();
			let that = this;
			that.$refs['form'].validateField('phoneNumber', (err)=>{
			  if(!err){
			    that.stateSms.sendBtn = true;
				let interval = window.setInterval(() => {
				  if (that.stateSms.time-- <= 0) {
				    that.stateSms.time = 60;
				    that.stateSms.sendBtn = false;
				    window.clearInterval(interval);
				  }
				}, 1000);
				const hide = Loading.service({ fullscreen: true, text: '验证码发送中..'});
				hide.close();
				postAction(that.url.sms, {phoneNumber: that.model.phoneNumber}).then(res => {
					if(!res.success){
						that.$notify.error({
							title: '错误',
							message: res.message
						});
					}
					hide.close();
				}).catch(err => {
                  hide.close();
                  clearInterval(interval);
                  that.stateSms.time = 60;
                  that.stateSms.sendBtn = false;
                });
			  }
			})
		},
		onSubmit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					postAction(this.url.add, this.model).then(res => {
						if (res.success) {
							this.model = res.result;
							this.$notify({
								title: '成功',
								message: '提交成功',
								type: 'success'
							});
						} else {
							this.$notify.error({
								title: '错误',
								message: '提交失败'
							});
						}
					})
				}
			})
		},
		onClickShowDialog() {
			this.dialogVisible = true;
		},
		handleClose() {
			this.dialogVisible = false;
		}
	}
}